import {
  livesDeleteLivePlaybacks,
  livesGetLivePlayback,
  livesGetLivePlaybackShareToken,
  livesListLivePlaybacks,
} from '@/app/services/live';

export { livesGetLivePlayback, livesListLivePlaybacks, livesDeleteLivePlaybacks };

export const getPlaybackDetail = (playbackId: string) => livesGetLivePlayback({ path: { id: playbackId } });

/** 生成/获取直播回放分享 token（分享前调用，用于拼接公开分享链接的 ?token=）。 */
export const getLivePlaybackShareToken = (playbackId: string) =>
  livesGetLivePlaybackShareToken({ path: { id: playbackId }, body: { id: playbackId } });
